/** @format */

import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { Breadcrumb } from '@shared/data-access/interfaces';
import { HmfBreadcrumbsComponent } from '@dsg-tech/homefield-angular';
import { Store } from '@ngrx/store';
import { selectBreadcrumbDetails } from '@pdp/data-access/state';

@Component({
	selector: 'pdp-breadcrumb',
	templateUrl: './breadcrumb.component.html',
	imports: [HmfBreadcrumbsComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbComponent {
	private readonly store = inject(Store);

	readonly breadcrumbDetails = this.store.selectSignal<Breadcrumb[]>(selectBreadcrumbDetails);

	readonly breadcrumbs = computed(() => this.breadcrumbDetails() || []);
}
